import React from "react";
import { Redirect, Route } from "react-router";
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs
} from "@ionic/react";
import { IonReactRouter } from "@ionic/react-router";
import { camera } from "ionicons/icons";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./pages/Home.css";
import Photos from "./pages/photo";

// import { Network } from "@capacitor/network";
import * as storage from "./utils/storage.js";

const INTERVAL_MINUTES = 1;
const SECONDS = 60;

const App: React.FC = () => {

  React.useEffect(() => {
    (async () => {
      await storage.getDeviceId();
    })();

  }, []);

  React.useEffect(() => {

  }, []);

  return (
    <IonApp>
      <IonReactRouter basename="/">
        <IonTabs>
          <IonRouterOutlet basePath="/photos">
            <Route path="/photos" component={Photos}  exact={true} />
            <Route exact path="/" render={() => <Redirect to="/photos" />} />
          </IonRouterOutlet>
          <IonTabBar slot="bottom">
            <IonTabButton tab="photos" href="/photos">
              <IonIcon icon={camera} /> 
              <IonLabel>Photos</IonLabel>
            </IonTabButton>
          </IonTabBar>
        </IonTabs>
      </IonReactRouter>
    </IonApp>
  );
};
 
export default App;
